import type { ChangeEvent } from 'react'
import React from 'react'

import { FormFieldStatus, InputField } from '@gousto-internal/citrus-react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

type PostcodeInputProps = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const PostcodeInput = ({ onChange }: PostcodeInputProps) => (
  <Field name="searchPostcode">
    {({ field, meta }: FieldProps) => (
      <InputField
        id={field.name}
        data-testid="checkoutPostcode"
        label="Postcode"
        width="100%"
        status={meta.touched && meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.touched ? meta.error : undefined}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...field}
        onChange={onChange}
      />
    )}
  </Field>
)
